export const SUBDOMAIN_REGEX = '^[^\\-][A-Za-z0-9\\-]*[^\\-]';

/**
 * Basic email regex, guards against two dots together
 */
export const EMAIL_REGEX =
  '^[\\w.%+-]+@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*\\.[A-Za-z]{2,}$';
